<template>
  <div @mouseleave="mouseleave">
    <nav ref="menuPopperTrigger" class="nav nav__desktop flex mr-1 relative">
      <div v-for="headerItem in headerCategories" :key="headerItem.name" class="menu__container u-center">
        <a
          ref="menuPopperTrigger"
          :href="IS_ONEDIO && headerItem.href"
          class="nav__link px-3 u-center h-[60px] text-lg font-medium cursor-pointer hover:bg-alpha-5 leading-tight text-center"
          :class="{
            'text-o-blue border-b-2 border-o-blue bg-alpha-5': selectedMenu && headerItem && selectedMenu.name === headerItem.name,
          }"
          :title="headerItem.shortName"
          aria-label="menu"
          @mouseover="mouseover(headerItem)"
        >
          {{ headerItem.shortName.toLocaleUpperCase(LANG) }}
        </a>
        <div
          v-show="selectedMenu && headerItem && selectedMenu.name === headerItem.name"
          class="absolute left-0 right-0 top-15 w-full bg-body-primary shadow-md border border-divider-100"
        >
          <CategoryMenu :selected-menu="headerItem" />
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { defineComponent, onBeforeUnmount, ref } from '@nuxtjs/composition-api';
import { OButton, OPopper } from '~/modules/common/components/ui';
import { useTracking } from '~/modules/tracking/composables/useTracking';
import categoryObject from '~/constants/categories.json';
import { LANG, IS_ONEDIO } from '~/constants/config';

export default defineComponent({
  name: 'PopoverMenu',
  serverCacheKey() {
    // Will change every 30 secondes
    if (categoryObject?.treeVersion) {
      return `HeaderDesktop2-${categoryObject.treeVersion}@86400`;
    }
    return 'HeaderDesktop2@300';
  },
  components: {
    OButton,
    OPopper,
    CategoryMenu: () => import(/* webpackChunkName: "CategoryMenu" */ '~/modules/common/components/app/header/CategoryMenu/CategoryMenu'),
  },
  setup() {
    const { sendMenuImpressionEvent, clearMenuImpressionTimer } = useTracking();

    const selectedMenu = ref(null);
    const mouseover = (item) => {
      selectedMenu.value = item;
      sendMenuImpressionEvent('desktop', { currentCategory: item });
    };
    const mouseleave = () => {
      clearMenuImpressionTimer();
      selectedMenu.value = null;
    };

    onBeforeUnmount(() => {
      clearMenuImpressionTimer();
    });

    const headerCategories = categoryObject.headerTree;
    const categories = categoryObject.categories;
    return { mouseover, mouseleave, headerCategories, categories, selectedMenu, LANG, IS_ONEDIO };
  },
});
</script>
